import React from "react"

import { ModalProps } from "../modal"
import { ModalBase } from "../modal-base"

export const Modal: React.FC<ModalProps> = ({ ...props }) => <ModalBase {...props} />
